import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eprescribe",
  "use": "icon-eprescribe-usage",
  "viewBox": "0 0 23 20",
  "content": "<symbol viewBox=\"0 0 23 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eprescribe\">\n<rect x=\"1\" y=\"1.6416\" width=\"8\" height=\"8\" rx=\"2\" stroke=\"#333333\" stroke-width=\"1.5\" />\n<path d=\"M22 3.88867H14.622M22 8.88867H14.622M22 13.8887H1M22 18.8887H1\" stroke=\"#333333\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol